import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import courseRequestService from "./courseRequestService";

// Submit a course request (POST)
export const createCourseRequest = createAsyncThunk(
  "courseRequest/create",
  async (requestData, thunkAPI) => {
    try {
      return await courseRequestService.createCourseRequest(requestData);
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Reset state
export const resetCourseRequestState = createAction("courseRequest/reset");

const initialState = {
  courseRequest: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
};

export const courseRequestSlice = createSlice({
  name: "courseRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCourseRequest.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCourseRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.courseRequest = action.payload;
      })
      .addCase(createCourseRequest.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(resetCourseRequestState, () => initialState);
  },
});

export default courseRequestSlice.reducer;
